<template>
    <div class="header-login">
        <span class="title-auth">
            {{ headerTitle }}
        </span>
        <img
            class="img-auth"
            :src="require('@/assets/imgs/svgs/commercia-logo.svg')"
            alt="Commercia Logo">
    </div>
</template>
<script>
export default {
  props: ['headerTitle'],
  name: 'HeaderAuth'
}
</script>
<style scoped>
.title-auth{
    font-size: 16px;
    font-weight: bold;
    margin-bottom: 50px;
}
.header-login{
    display: flex;
    flex-direction: column;
    align-items: center;
}
.img-auth{
    height: 44px;
}
</style>
